// removed by extract-text-webpack-plugin
module.exports = {"container":"ProductsContainer-module__container___1QWs3","item":"ProductsContainer-module__item___SqeX-","mobile":"ProductsContainer-module__mobile___3mu9G"};


//////////////////
// WEBPACK FOOTER
// ./src/js/widgets/Products/ProductsContainer.module.scss
// module id = 282
// module chunks = 0 1